import { render, staticRenderFns } from "./BlackfirstPrize.vue?vue&type=template&id=c6009860&scoped=true&"
import script from "./BlackfirstPrize.vue?vue&type=script&lang=js&"
export * from "./BlackfirstPrize.vue?vue&type=script&lang=js&"
import style0 from "./BlackfirstPrize.vue?vue&type=style&index=0&id=c6009860&prod&scoped=true&lang=less&"
import style1 from "./BlackfirstPrize.vue?vue&type=style&index=1&id=c6009860&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6009860",
  null
  
)

export default component.exports